import store from '@/store/index'
import Cookie from 'js-cookie'
// 客服地址
const udeskUrl = 'https://kuaidi100.udesk.cn/im_client/?web_plugin_id=128891'
// api管理后台登录
const loginUrl = `${process.env.VUE_APP_API_DOMAIN}/login?redirect=${process.env.VUE_APP_INDEX_DOMAIN}/expressIndex`

// 路径传参构建
function httpBuildQuery(params){
	return '?' + Object.keys(params)
		.filter(k => params[k])
		.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
		.join('&');
}

// 获取路径参数
function getQueryString(name) {
	let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	let r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return decodeURIComponent(r[2]);
	};
	return null;
}

// a标签下载文件
function downloadFile(url) {
	let link = document.createElement('a')
	link.style.display = 'none'
	link.href = process.env.VUE_APP_BASE_API + url
	link.setAttribute('target', `_blank`)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

// 判断是否有权限
function hasPermission(permissions = [], permissionType = 'or') {
	const performPermissions = store.getters.permissions
	if (permissionType === 'or') {
		if (permissions.some(perform => performPermissions.find((item => item.name == perform)))) {
			return true
		}
		return false
	} else {
		if (permissions.every(perform => performPermissions.find((item => item.name == perform)))) {
			return true
		}
		return false
	}
}

// 格式化时间YYYYmmDD
function formatTime(fmt, time) {
	const date = time;
	let ret;
	const opt = {
		"Y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"H+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"S+": date.getSeconds().toString() // 秒
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		};
	};
	return fmt;
}

// 获取cookie
const GET_COOKIE = function(name) {
	return Cookie.get(name, {
		domain: '.kuaidi100.com',
		path: '/'
	});
};

// 设置cookie
const SET_COOKIE = function(name, val) {
	Cookie.set(name, val, {
		expires: 1,
		path: '/',
		domain: '.kuaidi100.com'
	});
};

// 移除cookie
const REMOVE_COOKIE = function(name) {
	Cookie.remove(name, {
		domain: '.kuaidi100.com',
		path: '/'
	});
};

export {
	udeskUrl,
	loginUrl,
	httpBuildQuery,
	getQueryString,
	downloadFile,
	hasPermission,
	formatTime,
	GET_COOKIE,
	SET_COOKIE,
	REMOVE_COOKIE
}
